/**
 * Hash-based router
 * Matches routes, extracts params, and dispatches navigation events
 */

class Router {
  constructor() {
    this.routes = {};
    this._onHashChange = () => this.handleRoute();
  }

  /**
   * Register routes: { '/path': 'tag-name', '/path/:id': 'tag-name' }
   */
  register(routes) {
    this.routes = routes;
  }

  start() {
    window.addEventListener('hashchange', this._onHashChange);
    if (!window.location.hash) {
      window.location.hash = '#/';
    }
    this.handleRoute();
  }

  stop() {
    window.removeEventListener('hashchange', this._onHashChange);
  }

  handleRoute() {
    const hash = window.location.hash.slice(1) || '/';
    const { route, params } = this.matchRoute(hash);

    if (route && this.routes[route]) {
      window.dispatchEvent(new CustomEvent('route-change', {
        detail: { route, params, tagName: this.routes[route], path: hash },
      }));
    } else {
      window.location.hash = '#/';
    }
  }

  matchRoute(path) {
    // Exact match first
    if (this.routes[path]) {
      return { route: path, params: {} };
    }

    // Parameterized routes
    for (const route in this.routes) {
      const pattern = route.replace(/:[^/]+/g, '([^/]+)');
      const regex = new RegExp(`^${pattern}$`);
      const match = path.match(regex);

      if (match) {
        const paramNames = (route.match(/:[^/]+/g) || []).map((p) => p.slice(1));
        const params = {};
        paramNames.forEach((name, index) => {
          params[name] = match[index + 1];
        });
        return { route, params };
      }
    }

    return { route: null, params: {} };
  }

  navigate(path) {
    window.location.hash = `#${path}`;
  }
}

export const router = new Router();
